interface NewBadgeProps {
  /** When true renders a small dot (for sidebar nav items) instead of the full pill */
  dot?: boolean;
}

/**
 * Lightweight "NEW" indicator.
 * - Default: a small indigo pill with the text "NEW"
 * - dot=true: a compact dot for sidebar nav items where space is limited
 */
export default function NewBadge({ dot = false }: NewBadgeProps) {
  if (dot) {
    return (
      <span
        className="inline-block w-2 h-2 rounded-full bg-indigo-500 flex-shrink-0 ml-1.5"
        title="New feature available"
        aria-label="New feature"
      />
    );
  }
  return (
    <span
      className="inline-flex items-center px-1.5 py-0.5 text-[10px] font-bold bg-indigo-500 text-white rounded-full leading-none flex-shrink-0 ml-1.5"
      aria-label="New feature"
    >
      NEW
    </span>
  );
}
